export default function StatusBadge({ tone = "muted", children, testId }) {
  const map = {
    success: "bg-green-500/10 text-green-700 border-green-500/20",
    warning: "bg-amber-500/10 text-amber-700 border-amber-500/20",
    danger: "bg-red-500/10 text-red-600 border-red-500/20",
    info: "bg-blue-500/10 text-blue-600 border-blue-500/20",
    muted: "bg-muted text-muted-foreground border-border",
  };
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border ${map[tone] || map.muted}`}
    >
      {children}
    </span>
  );
}
